<template>
  <div class="uk-container uk-background-default">
    <div>
      {{ errorText }}
    </div>
    <div v-if="mainLoading">
      <div uk-spinner="ratio: 3"></div>
    </div>
    <div v-else>
      <br />

      <!-- <div v-if="user.onboardedPayments && user.onboardedTerminalLogins"> -->
      <div>
        <!-- @createdCustomer="refreshUserData" -->
        <div uk-flex>
          <button
            class="uk-button uk-button-large uk-button-primary uk-form-controls"
            v-on:click="showAddNew = !showAddNew"
          >
            <div v-if="showAddNew"><span uk-icon="icon: minus"></span>Close</div>
            <div v-else><span uk-icon="icon: plus"></span>New Carrier</div>
          </button>

          <transition name="slide">
            <div class="uk-background-sections rel" v-if="showAddNew">
              <!-- <button class="close&#45;btn" v&#45;on:click="showAddNew=false" uk&#45;close></button> -->
              <button
                class="uk-close-large close-btn"
                v-on:click="showAddNew = false"
                uk-close
              ></button>
              <h4 class="mt-0 uk-margin-top">Onboard New Carrier</h4>
              <EnterCarrier @addedCarrier="addedCarrier"></EnterCarrier>
            </div>
          </transition>

          <h2>My Carriers</h2>

          <!-- <div uk-switcher="animation: uk-animation-fade; toggle: > *">
            <button class="uk-button uk-button-default" type="button">
              Active
              <span class="uk-badge">{{ onboardingCarriers.length }}</span>
            </button>

            <button class="uk-button uk-button-default" type="button">
              Archived
              <span
                class="uk-badge"
                v-bind:class="{ 'uk-label-black': onboardingCarriers.length > 0 }"
                >{{ onboardingCarriers.length }}</span
              >
            </button>
          </div> -->

          <!-- <ul class="uk-switcher uk-margin">
            <li>
              <CarrierTable tableType="active" :carriers="onboardingCarriers"></CarrierTable>
            </li>

            <li>
              <CarrierTable tableType="archived" :carriers="onboardingCarriers"></CarrierTable>
            </li>
          </ul> -->
          <CarrierTable
            tableType="active"
            :brokerCarrierAssociations="companyCompanyAssociationCarriers"
          ></CarrierTable>
        </div>
        <div>
          <button class="uk-button uk-button-default" v-on:click="refreshCarrierData">
            <span uk-icon="refresh"></span> Refresh All Carrier Data
          </button>
        </div>

        <hr class="uk-divider-icon" />
      </div>

      <br />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';

// import EnterLoad from '../PODTracking/EnterLoad.vue';
import EnterCarrier from './EnterCarrier.vue';

import CarrierTable from './CarrierTable.vue';

import CompanyCompanyAssociationCarriersQuery from '../../gql/onboarding/CompanyCompanyCarriers.gql';

// import USER_ALL_DATA from '../../gql/pod_tracking/UserAllData.gql';
// import UPDATE_LOAD from '../../gql/pod_tracking/UpdateLoad.gql';

// declare let Cohere: any;

// const UIkit = require('uikit/src/js/uikit');
// @ts-ignore:
UIkit.use(Icons);

export default defineComponent({
  name: 'CarriersView',
  components: {
    EnterCarrier,
    CarrierTable,
    // CreateDriverModal,
    // CreateCustomerModal,
    // LoadModal,
    // ContainerTable,
    // Payments,
    // Profile,
  },
  data() {
    return {
      // selectedLoad: -1,
      loading: [],
      mainLoading: true,
      // errorText: 'default',
      errorText: null,
      showAddNew: false,
    };
  },
  computed: {},
  methods: {
    refreshCarrierData() {
      console.log('Refresh all carrier data called');
      (this as any).$apollo.queries.companyCompanyAssociationCarriers.refetch();
    },

    addedCarrier() {
      (this as any).showAddNew = false;
    },
  },
  props: {
    msg: String,
  },
  apollo: {
    companyCompanyAssociationCarriers: {
      query: CompanyCompanyAssociationCarriersQuery,
      result(result) {
        const vm = (this as any);

        vm.mainLoading = false;
        console.log('ONBOARDING CARRIER', result);
        vm.errorText = null;
      },
      error(error) {
        const vm = (this as any);

        vm.mainLoading = false;
        console.error('Fetching user data failed: ', error);
        // this.error = 'Getting user data from server failed - are you connected to the internet?';
        vm.errorText = 'new error';
        // this.errorText = JSON.stringify(error.message);
        console.log('err: ', (this as any).errorText);
      },
    },
  },
});
</script>

<style lang="scss">
.uk-icon[uk-icon='icon: file-pdf'] svg {
  color: red;
}

.uk-background-sections {
  background-color: #b1d5e5;
}

.close-btn {
  position: absolute;
  top: 5px;
  right: 10px;
}

.mt-0 {
  margin-top: 0px;
}

.rel {
  position: relative;
}

.add-new-load-btn-slide-enter-active,
.slide-enter-active {
  -moz-transition-duration: 0.1s;
  -webkit-transition-duration: 0.1s;
  -o-transition-duration: 0.1s;
  transition-duration: 0.1s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

/* .add-new-load-btn-slide-leave-active, .slide-leave-active { */
.slide-leave-active {
  -moz-transition-duration: 0.2s;
  -webkit-transition-duration: 0.2s;
  -o-transition-duration: 0.2s;
  transition-duration: 0.2s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.add-new-load-btn-slide-enter-to,
.add-new-load-btn-slide-leave,
.slide-enter-to,
.slide-leave {
  max-height: 100px;
  overflow: hidden;
}

/*.add-new-load-btn-slide-enter, .add-new-load-btn-slide-leave-to, .slide-enter, .slide-leave-to {*/
.add-new-load-btn-slide-enter,
.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>
